define('plugin/google-analytic/GoogleAnalyticPlugin',['require','lib/plugin/PluginAbstract','cookieblock','Config','lib/plugin/PluginBroker'],function (require) {

    var PluginAbstract = require('lib/plugin/PluginAbstract');
    var CookieBlock = require('cookieblock');
    var Config = require('Config');
    var PluginBroker = require('lib/plugin/PluginBroker');

    return PluginAbstract.extend({

        _collection: null,
        gtag: null,
        cookiesAccepted: false,
        _thData : null,
        _thTimer : null,
        _thTimeout : 1500,


        initialize: function () {
            var version = Config.getInstance().getOption('company_ga_vers');

            require(['google_universal_analytic'], _.bind(this._initUa, this));

            Backbone.history.on('route', _.bind(function (){
                this._thAddPageView();
            }, this));

            Backbone.Wreqr.radio.channel('page').vent.on(
                'shown', _.bind(this._thAddPageView, this)
            );
            Backbone.Wreqr.radio.channel('booking').vent.on(
                'step:changed', _.bind(this._thAddPageView, this)
            );

            Backbone.Wreqr.radio.channel('client_login').vent.on('client:signin', _.bind(this._onClientLogin, this));
            Backbone.Wreqr.radio.channel('client_login').vent.on('client:signout', _.bind(this._onClientLogout, this));

            this.cookiesAccepted = window.cookiesAccepted;
        },

        _initUa: function () {
            var _this = this;
            window.dataLayer = window.dataLayer || [];
            this.gtag = function (){
                window.dataLayer.push(arguments);
            }

            $.cookie('cookies_accepted')
            if (allowCookies && this.gtag) {
                this.gtag('js', new Date());
                //Приведенный ниже код в глобальном теге отслеживания gtag.js отправляет обращение pageview в ресурс Google Аналитики
                //https://developers.google.com/analytics/devguides/collection/gtagjs/migration?hl=ru
                var configData = {
                    send_page_view: false,
                    linker: {
                        accept_incoming: true
                    }
                };

                if(Config.getInstance().getOption('widget_hostname')){
                    configData['linker']['domains'] = [Config.getInstance().getOption('widget_hostname'), window.location.hostname];
                }

                if (!this._clientModel && Config.getInstance().getPluginStatus('client_login')) {
                    var clientPlugin = PluginBroker.getInstance().getPlugin('client_login');
                    this._clientModel = clientPlugin.getClientModel();
                    var isLogged = this._clientModel.get('is_logged_in');
                    if(isLogged) {
                        configData['user_id'] = this._clientModel.get('id');
                    }
                }
                this.gtag('config', Config.getInstance().getOption('company_ga_tracking_id'), configData);
                //this._addPageView(); //not needed ^
            } else if (!this.cookiesAccepted) {
                CookieBlock.addAcceptedHandler(function () {
                    _this._initUa();
                });
                this.cookiesAccepted = true;
                //NB defer showing cookie block until page (and cookie block in particular) is rendered
                setTimeout(function () {
                    CookieBlock.show();
                });
            }
        },

        _thAddPageView: function (options) {
            var _this = this;
            if(options && options.page){
                this._thData = options;
            }

            if(options && options.step){
                this._thData = {
                    page: 'booking -> ' + options.step,
                }
            }

            clearTimeout(this._thTimer);
            this._thTimer = setTimeout(function (){
                _this._addPageView(_this._thData);
                _this._thData = null;
            }, this._thTimeout);
        },

        _addPageView: function (options) {
           // console.log(options, Backbone.history.getFragment());

            if(this.gtag){
                var eventData = {
                    'send_to': Config.getInstance().getOption('company_ga_tracking_id'),
                    'page_path' : '/#' + Backbone.history.getFragment(),
                };

                if(options && options.page){
                    eventData = _.extend(eventData, {
                       'page_title' :  document.title + (options.page !== 'index' ? ' | ' + options.page : ''),
                    });
                }
                //console.log(eventData);
                this.gtag('event', 'page_view', eventData);
            }
        },

        _onClientLogin : function (params){
            if(this.gtag){
                this.gtag('config', Config.getInstance().getOption('company_ga_tracking_id'), {
                    'user_id' : params.id,
                });
            }
        },

        _onClientLogout : function (params){
            if(this.gtag){
                this.gtag('config', Config.getInstance().getOption('company_ga_tracking_id'), {
                    'user_id' : null,
                });
            }
        },

        finishBooking: function (bookingRequestModel) {
            this._collection = bookingRequestModel.get('bookings');

            require(['google_adwords'], _.bind(this._addConversion, this));
        },

        onFinishBooking : function (data) {
            if(data && data.confirm && this.gtag) {  //booking confirmed
                var invoice = data.invoice;
                var bookingIds = data.booking_ids || [];

                var cdata = {
                    currency: (invoice && invoice.get('id')) ? invoice.get('currency') : null,
                    transaction_id: (invoice && invoice.get('id')) ? invoice.get('number') : bookingIds.join(','),
                    value: (invoice && invoice.get('id')) ? invoice.get('amount') : null,
                    items: [],
                };

                _.each(data.bookings.models, function (model) {
                    var service = model.get('service');

                    if (!service){
                        return;
                    }

                    cdata.items.push({
                        id: service.id,
                        name: service.name,
                        quantity: parseInt(model.get('count')),
                        price: parseFloat(service.price),
                    });
                });

                if (cdata.items){
                    if ((invoice && invoice.get('id'))) {
                        this.gtag("event", "begin_checkout", cdata);
                    } else {
                        this.gtag("event", "purchase", cdata);
                    }
                }
            }
        },

        /**
         * On finish payment
         *
         * @param view
         * @param data
         * @param invoice
         */

        onFinishPayment: function (view , data, invoice) {
            if (this.gtag) {
                var bookingIds = data.booking_ids || [];

                var cdata = {
                    currency: (invoice && invoice.get('id')) ? invoice.get('currency') : null,
                    transaction_id: (invoice && invoice.get('id')) ? invoice.get('number') : bookingIds.join(','),
                    value: (invoice && invoice.get('id')) ? invoice.get('amount') : null,
                    items: [],
                };

                invoice.get('lines').each(function (model) {
                    var bookings = model.get('bookings');

                    var lineName = model.get('name');

                    // take all characters before the first opening bracket, if there is any, or whole string otherwise
                    var bracketIndex = lineName.indexOf('(');
                    var serviceName = bracketIndex > 0 ? lineName.substr(0, bracketIndex).trim() : lineName;

                    if(!bookings || !bookings.length){
                        return;
                    }
                    // assume each booking line can contain only one booking, even though data structure allows multiple
                    var booking = bookings[0];

                    // _.each(bookings, function (booking) {
                        cdata.items.push({
                            id: booking.service_id,
                            name: serviceName,
                            quantity: parseInt(model.get('qty')),
                            price: parseFloat(model.get('price')),
                        });
                    // });
                });

                if (!sessionStorage.getItem('transaction_id') || sessionStorage.getItem('transaction_id') !== cdata.transaction_id) {
                    sessionStorage.setItem('transaction_id', cdata.transaction_id);
                    this.gtag("event", "purchase", cdata);
                }
            }
        },

        _addConversion: function (trackConversion) {
            var config = Config.getInstance();
            this._collection.each(function (model) {
                var value = config.getOption('google_conversion_value');
                var currency = config.getOption('google_conversion_currency');
                var service = model.get('service');
                if (service && service.price) {
                    value = service.price;
                    currency = service.currency;
                }

                trackConversion({
                    google_conversion_id: config.getOption('google_conversion_id'),
                    google_conversion_language: config.getOption('google_conversion_language'),
                    google_conversion_format: config.getOption('google_conversion_format'),
                    google_conversion_color: config.getOption('google_conversion_color'),
                    google_conversion_label: config.getOption('google_conversion_label'),
                    google_conversion_value: value,
                    google_conversion_currency: currency,
                    google_custom_params: {
                        service_id: model.get('service_id'),
                        provider_id: model.get('provider_id')
                    }
                });
            });
        }

    });

});

